<template>
  <b-card no-body>
    <b-card-body class="d-flex justify-content-between align-items-center">
        <span>{{ statisticTitle }}</span>
        <h2 class="mb-25 font-weight-bolder">
          {{ statistic }}
        </h2>
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardBody, BAvatar } from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BCardBody,
    BAvatar,
  },
  props: {

    statistic: {
      type: [Number, String],
      required: true,
    },
    statisticTitle: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: 'primary',
    },
  },
}
</script>
